import moment from 'moment';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { MdOutlineNavigateBefore, MdOutlineNavigateNext } from 'react-icons/md';
import Carousel from 'react-simply-carousel';
import AlertModal from '../../../../components/alertModal/alertModal';
import DonutChartWithLabel from '../../../../components/donutChartWithLabel/DonutChartWithLabel';
import EmptyMessage from '../../../../components/emptyMessage/EmptyMessage';
import EmptyPlaceholder from '../../../../components/emptyPlaceholder/EmptyPlaceholder';
import UsageSummeryContainer from '../../../../components/usageSummeryContainer/UsageSummeryContainer';
import { EPackageType } from '../../../../interfaces/packageType';
import { ISubscriberData } from '../../../../interfaces/subscriberData';
import { IVod } from '../../../../interfaces/vod';
import { getSubscriberData } from '../../../../services/dashboard';
import { bytesToGb } from '../../../../util/bytesToGb';

interface IProps {
  selectedCircuitId?: string;
  selectedPackageType: EPackageType;
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const AddOnUsage = (props: IProps) => {
  const { loading, setLoading, selectedPackageType, selectedCircuitId } = props;
  const [error, setError] = useState<string>('');
  const [activeSlide, setActiveSlide] = useState(0);
  const [userPackage, setUserPackage] = useState<string>('');
  const [subscriberData, setSubscriberData] = useState<ISubscriberData>();

  useEffect(() => {
    if (selectedCircuitId) {
      setLoading(true);

      getSubscriberData(selectedCircuitId)
        .then((data: ISubscriberData) => {
          setSubscriberData(data);
          setLoading(false);
        })
        .catch((error) => {
          setError(
            error.message === 'null'
              ? 'There are no addon usage records.'
              : error.message
          );
          setLoading(false);
        });
    }
  }, [selectedCircuitId, setLoading, selectedPackageType]);

  useEffect(() => {
    if (
      !subscriberData?.vod[activeSlide] ||
      !subscriberData?.vod[activeSlide]?.vodPackage
    ) {
      setUserPackage('');
      return;
    }
    setUserPackage(subscriberData?.vod[activeSlide].vodPackage || '');
  }, [activeSlide, subscriberData]);

  return (
    <UsageSummeryContainer
      title={
        <>
          <Row>
            <Col className='col-12 col-md'>
              Addon Usage{' '}
              {subscriberData &&
                `as at ${moment(new Date()).format('yyyy-MM-DD hh:mm A')}`}
            </Col>
            {userPackage && (
              <Col className='col-auto'>User Package: {userPackage}</Col>
            )}
          </Row>
        </>
      }
    >
      <Row className='justify-content-center mt-5'>
        <Col
          className={subscriberData?.vod.length === 1 ? 'col-auto' : 'col-12'}
        >
          {subscriberData && subscriberData?.vod.length > 0 && (
            <Carousel
              containerProps={{
                style: {
                  width: '100%',
                  justifyContent: 'space-between',
                  userSelect: 'text',
                },
              }}
              activeSlideIndex={activeSlide}
              onRequestChange={setActiveSlide}
              backwardBtnProps={{
                children: activeSlide !== 0 && (
                  <MdOutlineNavigateBefore size={30} color='#004888' />
                ),
                style: {
                  alignSelf: 'center',
                  border: 'none',
                  background: 'white',
                },
              }}
              forwardBtnProps={{
                children: activeSlide !== subscriberData.vod.length - 1 && (
                  <MdOutlineNavigateNext size={30} color='#004888' />
                ),
                style: {
                  alignSelf: 'center',
                  border: 'none',
                  background: 'white',
                },
              }}
              dotsNav={{
                show: false,
              }}
              itemsToShow={1}
              speed={400}
              infinite={false}
            >
              {subscriberData?.vod.map((vod: IVod, index) => {
                const used = bytesToGb(+vod.vodTotalBytes) - bytesToGb(+vod.vodRemainBytes);
                const remain = bytesToGb(+vod.vodRemainBytes);

                return (
                  <DonutChartWithLabel
                    key={index}
                    data={[
                      {
                        label: `USED`,
                        value: used,
                      },
                      {
                        label: `REMAINING`,
                        value: remain,
                      },
                    ]}
                    totalQuotaBytes={bytesToGb(+vod.vodTotalBytes)}
                    remainQuotaBytes={remain}
                    expiryDate={vod.vodExpiryDate}
                  />
                );
              })}
            </Carousel>
          )}

          {!props.selectedCircuitId && <EmptyPlaceholder className='mt-5' />}
          <EmptyMessage
            show={
              (!loading && !!props.selectedCircuitId && !!!subscriberData) ||
              (subscriberData?.vod && subscriberData.vod.length <= 0) ||
              false
            }
            message='There are no records'
          />
        </Col>
      </Row>

      <AlertModal
        show={!!error}
        variant='error'
        buttons={[
          {
            text: 'OK',
            variant: 'success',
            onClick: () => setError(''),
          },
        ]}
      >
        {error}
      </AlertModal>
    </UsageSummeryContainer>
  );
};

export default AddOnUsage;
